import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action, autorun, toJS} from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, {FormBody, FormActions, TextInput, SelectInput} from '../Form';

@inject('folderStore', 'stationStore')
@observer
class FolderStationEdit extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  static propTypes = {
    route: PropTypes.object.isRequired,
  };

  @observable station = {
    id: '',
    identifier: '',
    name: '',
    description: '',
    folder_id: ''
  };

  @observable folder = {
    name: '',
  };

  slug = '/folder';
  title = 'Edit Station';

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
    this.init();
  }

  @action init() {
    const {folderStore, params: {id, stationId}} = this.props;
    this.station.folder_id = id;
    this.station.id = stationId;
  }

  dispose;

  componentWillMount() {
    const {folderStore, stationStore, params: {id, stationId}} = this.props;

    folderStore.fetchItem(id);
    stationStore.fetchItem(stationId);

    this.dispose = action(autorun(() => {
      this.folder = folderStore.findById(id);
      const foundStation = stationStore.findById(stationId);
      if (foundStation) {
        // console.log('foundStation', foundStation.asJson, toJS(foundStation));
        this.station = {
          id: stationId,
          identifier: foundStation.identifier,
          name: foundStation.name,
          description: foundStation.description,
          folder_id:id
        };
        // console.log('this.station', this.station, toJS(this.station));
      }
    }));
  }

  componentWillUnmount() {
    this.dispose();
  }

  @action onChangeName = (e) => {
    this.station.name = e.target.value;
  }
  @action onChangeDescription = (e) => {
    this.station.description = e.target.value;
  }
  @action onChangeIdentifier = (e) => {
    this.station.identifier = e.target.value;
  }

  handleSave(e) {
    e.preventDefault();

    const {notify} = this.context;
    const {folderStore, stationStore, params: {id}} = this.props;
    console.log('this.station', this.station);
    stationStore
      .updateItem(this.station)
      .then(action(() => {
        folderStore.updateStation(this.station, id);
        notify.success();
        this.context.router.push(this.slug);
      }))
      .catch(action(err => {
        console.log('err', err);
        notify.error(err);
      }));
  }

  onChangeFolder = e => this.station.folder_id = e.target.value;

  render() {
    const {
      params: {id: projectId},
      stationStore,
      folderStore
    } = this.props;

    if (stationStore.isLoading) {
      return <Spinner />;
    }
    const projectName = (this.folder && this.folder.name) || '';

    return (
      <Modal title={this.title} slug={this.slug} isSaving={stationStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Station Name'}
                       value={this.station.name}
                       onChange={this.onChangeName}/>
            <TextInput label={'Identifier'}
                       value={this.station.identifier}
                       onChange={this.onChangeIdentifier}/>
            <SelectInput label={'Project'}
                         value={this.station.folder_id}
                         fields={{label: 'name', value: 'id'}}
                         options={folderStore.items.toJS()}
                         onChange={this.onChangeFolder}/>
            <TextInput
              label={'Description'}
              value={this.station.description}
              onChange={this.onChangeDescription}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default FolderStationEdit;



// WEBPACK FOOTER //
// ./src/components/Folder/FolderStationEdit.js